<script>
import { Doughnut, mixins } from 'vue-chartjs';

const { reactiveProp } = mixins;

export default Doughnut.extend({
  props: ['options'],
  mixins: [reactiveProp],
  mounted() {
    /* eslint-disable no-underscore-dangle */
    this.renderChart(this.chartData, this.options);
    this.$emit('chartCreated', this._chart);
  },
});
</script>



// WEBPACK FOOTER //
// BaseDoughnutChart.vue?40366f02